/* Little Wins hero — muted autoplay that only runs while the media is on screen.
   No dependencies. Degrades to a static poster when autoplay is unavailable. */
(function () {
  var ROOT = 'little-wins-hero';
  var wraps = document.querySelectorAll('.' + ROOT + '__media--auto');
  if (!wraps.length) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  Array.prototype.forEach.call(wraps, function (wrap) {
    var video = wrap.querySelector('video');
    if (!video) return;
    var toggle = wrap.querySelector('[data-lw-toggle]');

    // Browsers only permit autoplay while muted; enforce it rather than trusting markup.
    video.muted = true;
    video.setAttribute('muted', '');

    var userPaused = false;
    var visible = false;

    function allowed() {
      return visible && !userPaused && !reduce.matches;
    }

    function tryPlay() {
      if (!allowed()) return;
      var p = video.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    }

    video.addEventListener('playing', function () {
      wrap.classList.add('is-playing');
    });

    video.addEventListener('pause', function () {
      wrap.classList.remove('is-playing');
      // The theme's pauseAllMedia() stops every <video> on the page. If that
      // (rather than the visitor) caused this, pick back up.
      if (allowed()) window.requestAnimationFrame(tryPlay);
    });

    if (toggle) {
      toggle.setAttribute('aria-pressed', 'false');
      toggle.addEventListener('click', function () {
        userPaused = !video.paused;
        if (userPaused) video.pause();
        else tryPlay();
        toggle.setAttribute('aria-pressed', String(userPaused));
      });
    }

    // Honour reduced motion from the first frame, before anything plays.
    if (reduce.matches) {
      video.removeAttribute('autoplay');
      video.pause();
    }
    if (typeof reduce.addEventListener === 'function') {
      reduce.addEventListener('change', function () {
        if (reduce.matches) video.pause();
        else tryPlay();
      });
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            visible = entry.isIntersecting;
            if (visible) tryPlay();
            else video.pause();
          });
        },
        { threshold: 0.25 }
      ).observe(wrap);
    } else {
      visible = true;
      tryPlay();
    }
  });
})();

/* "Watch the film": plays the film with sound in a native <dialog>. Closing it
   (button, backdrop click or Esc) stops playback and rewinds. */
(function () {
  var opens = document.querySelectorAll('[data-lw-film-open]');
  Array.prototype.forEach.call(opens, function (btn) {
    var modal = document.getElementById(btn.getAttribute('aria-controls'));
    if (!modal || typeof modal.showModal !== 'function') return;
    var video = modal.querySelector('video');
    var close = modal.querySelector('[data-lw-film-close]');

    function stop() {
      if (!video) return;
      video.pause();
      try { video.currentTime = 0; } catch (e) {}
    }

    btn.addEventListener('click', function () {
      modal.showModal();
      document.body.classList.add('lw-film-open');
      if (video) {
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      }
    });

    if (close) close.addEventListener('click', function () { modal.close(); });

    // A click on the dimmed backdrop lands on the <dialog> itself.
    modal.addEventListener('click', function (e) {
      if (e.target === modal) modal.close();
    });

    modal.addEventListener('close', function () {
      stop();
      document.body.classList.remove('lw-film-open');
      btn.focus();
    });
  });
})();
